module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer text-right"
  }, [_c('ladda-button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "on-click": _vm.handleGenerateReport
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-download fa-fw"
  }), _vm._v(" Download XLS\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h2', [_vm._v("System Users Report")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-content report-box",
    staticStyle: {
      "min-height": "125px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("\n        Generate a report that outputs all users in the system and some details\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-691539ea"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/SystemUsersReport.vue
// module id = 1030
// module chunks = 0